// ie polyfill
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import Cookies from 'js-cookie'
import vue_const from './utils/const.js'
import Copywriting from './utils/Copywriting.js'
import vue_constmethods from './utils/constmethods.js'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/'
import i18n from './locales'
import { VueAxios } from './utils/request'
import ProLayout, { PageHeaderWrapper } from '@ant-design-vue/pro-layout'
import themePluginConfig from '../config/themePluginConfig'
import vcolorpicker from 'vcolorpicker'
import '@/assets/css/main.css'
// import '@/assets/css/mian.less'
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
import $ from 'jquery'
// mock
import './mock'
console.log('qqq')
import bootstrap from './core/bootstrap'
import './core/lazy_use' // use lazy load components
import './permission' // permission control
import './utils/filter' // global filter
// import 'ant-design-vue/dist/antd.less'
import './global.less' // global style

import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';


Vue.use(Antd);


Vue.config.productionTip = false

// mount axios Vue.$http and this.$http
Vue.use(VueAxios)
Vue.use(vue_const)
Vue.use(Copywriting)
Vue.use(vue_constmethods)
Vue.use(vcolorpicker)
Vue.component('pro-layout', ProLayout)
Vue.component('page-container', PageHeaderWrapper)
Vue.component('page-header-wrapper', PageHeaderWrapper)
window.umi_plugin_ant_themeVar = themePluginConfig.theme

new Vue({
  router,
  store,
  i18n,
  created: bootstrap,
  render: h => h(App)
}).$mount('#app')
